import { Button } from 'react-bootstrap';
import styled from 'styled-components';

import { Frame, RowWrapper, TExtra } from 'components/StyledTemplates/StyledTemplates';

export const Workspace = styled(Frame)<{ extra?: TExtra }>`
    width: 100%;
    height: calc(100vh - 70px);

    ${({ extra }) => extra}
`;

export const Wrapper = styled(Frame)<{ extra?: TExtra }>`
    max-width: 1400px;
    width: 96vw;
    margin-top: 100px;
    margin-bottom: 50px;
    flex-direction: row;
    align-items: flex-start;

    /* > * {
        width: 100%;
        flex: 1;
        align-items: flex-start;
    } */

    ${(props: any) => props.extra}
`;

export const Header = styled(RowWrapper)`
    /*font-family: 'Marcellus';*/
    font-size: 25px;
    line-height: 30px;
    color: #343a40;
    margin-bottom: 22px;
`;

export const DashboardButton = styled(Button).attrs((props) => {
    return {
        ...props,
    };
})`
    width: 133px;
    min-width: unset;
    font-size: 14px;
    font-weight: 600;
    line-height: 26px;
    /*font-family: Open Sans, serif;*/
`;
